import React, { useState } from "react";
import styles from "./style.module.css";
import Loader from "../../components/loader";
import { baseUrl } from "../../services/api";
import userIcon from "../../assets/images/user-icon-removebg.png";
import "./style.css";

const TeacherAllDetails = ({ data }) => {
  const [loading, setLoading] = useState(false);
  //   const [data, setData] = useState({});

  const groupSlotsByDay = (data) => {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const formattedData = data?.reduce((acc, item) => {
      if (item?.day && item?.startTime && item?.endTime && item?.isEnabled) {
        const formattedSlot = {
          startTime: new Date(
            `1970-01-01T${item?.startTime}Z`
          ).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          endTime: new Date(`1970-01-01T${item?.endTime}Z`).toLocaleTimeString(
            "en-US",
            { hour: "2-digit", minute: "2-digit", hour12: true }
          ),
        };
        const dayIndex = daysOfWeek.indexOf(item?.day);
        if (dayIndex !== -1) {
          if (!acc[dayIndex]) {
            acc[dayIndex] = { day: item.day, slots: [formattedSlot] };
          } else {
            acc[dayIndex].slots.push(formattedSlot);
          }
        }
      }
      return acc;
    }, []);

    // Remove undefined entries if any and return the result
    return formattedData?.filter(Boolean);
  };

  const groupedSlots = groupSlotsByDay(data?.teacherAvailabilities || []);
  const profilePicture = data?.teacherMedia?.find(
    (profile) => profile.type === "profilePicture"
  );

  return (
    <div className={styles.container}>
      {loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        <div className={styles.card}>
          <div className={`${styles.cardHeader} ${styles.textCenter}`}>
            <h2>{data?.fullName}</h2>
          </div>
          <div className={`${styles.cardBody}`}>
            <div className={`row ${styles.mb3} align-items-end`}>
              <div className={`col-md-3 ${styles.textCenter}`}>
                {profilePicture ? (
                  <img
                    src={`${baseUrl}${profilePicture?.url}`}
                    alt="profile"
                    className={`${styles.imgFluid} ${styles.roundedCircle}`}
                    style={{ aspectRatio: 1 / 1, objectFit: "cover" }}
                  />
                ) : (
                  <img src={userIcon} alt="" style={{ width: "80%" }} />
                )}
              </div>
              <div className="col-md-9">
                <p>
                  <strong>Name:</strong> {data?.fullName}
                </p>
                <p>
                  <strong>Address:</strong>{" "}
                  {`${data?.country?.name}, ${data?.province?.name}, ${data?.city?.name}, ${data?.area?.name}`}
                </p>
                <p>
                  <strong>Email:</strong> {data?.email}
                </p>
                <p>
                  <strong>Phone:</strong> {data?.phoneNumber}
                </p>
              </div>
            </div>
            <div className={styles.mb3}>
              <div className="d-flex justify-content-between mb-2 flex-wrap">
                <strong>
                  <p>Teaching Preference</p>
                </strong>
              </div>
              {data?.courses?.length > 0 ? (
                <ul className="list-group">
                  {data.courses.map((course, index) => (
                    <li key={index} className="list-group-item">
                      <strong>{course?.courseSubjectName}</strong> (
                      {course?.courseHeaderName})
                      <ul>
                        {course?.courseOfferingLevels?.map(
                          (level, levelIndex) => (
                            <li key={levelIndex}>{level?.courseLevelName}</li>
                          )
                        )}
                      </ul>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No courses added</p>
              )}
            </div>

            <div className={styles.mb3}>
              <div className="d-flex justify-content-between mb-2 flex-wrap">
                <strong>
                  <p>Education</p>
                </strong>
              </div>
              {data?.teacherEducations?.length > 0 ? (
                <ul className="list-group">
                  {data.teacherEducations.map((edu, index) => (
                    <li key={index} className="list-group-item">
                      <strong>{edu?.qualification}</strong> ({edu?.institute})
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No education details added</p>
              )}
            </div>

            <div className={styles.mb3}>
              <div className="d-flex justify-content-between mb-2 flex-wrap">
                <strong>
                  <p>Documents</p>
                </strong>
              </div>
              {data?.teacherMedia?.length > 0 ? (
                <ul className="list-group">
                  {data?.teacherMedia?.map((doc, index) => (
                    <li key={index} className="list-group-item">
                      <a
                        href={`${baseUrl}${doc?.url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {doc.type}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No documents uploaded</p>
              )}
            </div>

            <div className={styles.mb3}>
              <div className="d-flex justify-content-between mb-2 flex-wrap">
                <strong>
                  <p>Experiences</p>
                </strong>
              </div>

              <h6>Academic Experience</h6>
              {data?.teacherAcademicExperiences?.length > 0 ? (
                <ul className="list-group">
                  {data?.teacherAcademicExperiences.map((exp, index) => (
                    <li key={index} className="list-group-item">
                      {exp?.organization}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No academic experience added</p>
              )}
              <h6 className="mt-3">Corporate Experience</h6>
              {data?.teacherCorporateExperiences?.length > 0 ? (
                <ul className="list-group">
                  {data.teacherCorporateExperiences.map((exp, index) => (
                    <li key={index} className="list-group-item">
                      {exp?.organization}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No corporate experience added</p>
              )}
            </div>

            <div>
              <div className="d-flex justify-content-between mb-2 flex-wrap">
                <strong>
                  <p>Teaching Slots (Saturday to Sunday)</p>
                </strong>
              </div>
              {groupedSlots?.length > 0 ? (
                groupedSlots?.map((day, index) => (
                  <div key={index} className={styles.mb2}>
                    <h6>{day.day}</h6>
                    <ul className="list-group">
                      {day.slots.map((slot, slotIndex) => (
                        <li key={slotIndex} className="list-group-item">
                          {slot.startTime} - {slot.endTime}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              ) : (
                <p>No teaching slots added</p>
              )}
            </div>
            <hr />
            <div>
              <div className="d-flex justify-content-between mb-2 mt-3 flex-wrap">
                <strong>
                  <p>Teaching Mode</p>
                </strong>
              </div>
              <h6 className={`${styles["teaching-mode"]} `}>
                {data?.modeOfTeaching}
              </h6>
              {data?.modeOfTeaching !== "" && data?.teacherAreas?.length > 0 ? (
                <ul className="list-group">
                  {data.teacherAreas.map((place, index) => (
                    <li key={index} className="list-group-item">
                      <strong>{place?.countryName}</strong> (
                      {place?.provinceName}, {place?.cityName},{" "}
                      {place?.areaName})
                      <ul>
                        <li>{place?.subAreaName}</li>
                      </ul>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No area added</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherAllDetails;
